import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import TourTicket from '../models/TourTicket';

export function getTourTickets(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TICKET_LIST,
        params: params,
        parser: tourTicketsDataParser,
    }).get();
}

export function getAllTourTickets() {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TICKET_LIST_ALL,
        parser: tourTicketsAllDataParser,
    }).get();
}

export function getTourTicketDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TICKET_DETAIL,
        endpointParams: { id },
        parser: data => new TourTicket(data.data),
    }).get();
}

export function createTourTicket(tourTicket) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TICKET_CREATE,
    }).post(tourTicket.export());
}

export function updateTourTicket(tourTicket) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TICKET_CREATE,
    }).put(tourTicket.export());
}

export function deleteTourTicket(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TICKET_DELETE,
        endpointParams: { id },
    }).delete();
}

export function createTourTicketTranslate(tourTicket) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TICKET_TRANSLATE_CREATE,
    }).post(tourTicket.export(true).translate());
}

export function updateTourTicketTranslate(tourTicket) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TICKET_TRANSLATE_UPDATE,
    }).put(tourTicket.export(true).translate());
}

export function deleteTourTicketTranslate(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TICKET_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

export function getAllTourTicketsById(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TICKET_LIST_ALL_BY_ID,
        endpointParams: { id },
    }).get();
}


function tourTicketsDataParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new TourTicket(item))
    }
}

function tourTicketsAllDataParser(data = {}) {
    return {
        result: (data.data || []).map(item => new TourTicket(item))
    }
}
